module.exports = __webpack_public_path__ + "img/ps3.96a1d3a7.jpg";